<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">Compartilhar Evento</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form class="form">
        <img :src="`${API}/barcode/qrcode/${encodeURIComponent(show.shortUrl)}`" />
        <div @click="copy" class="search-input">
          <input type="text" id="shortUrl" :value="show.shortUrl" readonly />
          <i class="far fa-copy"></i>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ShowCancel',
  props: ['show', 'close'],
  data () {
    return {
      API: process.env.VUE_APP_API
    }
  },
  methods: {
    copy () {
      const copyText = document.getElementById('shortUrl')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(copyText.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.form {
  img {
    width: 300px;
    height: auto;
    margin: 0 auto;
  }
}

.search-input {
  width: 260px;
  position: relative;
  margin: 0 auto 20px;
  cursor: pointer;
  input {
    display: block;
    width: 100%;
    margin: 0;
    cursor: pointer !important;
  }
  i {
    position: absolute;
    top: 6px;
    right: 10px;
    color: $secondary-color;
    font-size: 1.5em;
  }
}
</style>
